import { Pipe, PipeTransform } from "@angular/core";
import { ProductsService } from "@shared/services/products.service";
import { Observable, of } from "rxjs";
import { map, shareReplay, take } from "rxjs/operators";

@Pipe({
  name: 'getBrandLogo'
})
export class GetBrandLogoPipe implements PipeTransform {
  constructor(private productsService: ProductsService) {}

  transform(brand: string): Observable<string> {
    return this.productsService.products$.pipe(
      take(1),
      map(result => {
        if (!result?.availableBrands) {
          return `./assets/logos/${brand.replace(/\s/g, "").toLowerCase()}.png`;
        }
        const foundBrand = result.availableBrands.find(b => b.name.toLowerCase() === brand.toLowerCase());
        return foundBrand?.logoUrl || `./assets/logos/${brand.replace(/\s/g, "").toLowerCase()}.png`;
      }),
      shareReplay({bufferSize: 1, refCount: true})
    );
  }
}
